import { aiProviderIdSchema, type AiProviderId } from './runtime.js';
import { aiProviderStatusIdSchema, type AiProviderStatusId } from './role-config.js';

/** Exhaustive admin credential provider ids (zod SSOT). */
export const AI_PROVIDER_STATUS_IDS = aiProviderStatusIdSchema.options;

/** Exhaustive runtime text-gateway provider ids (zod SSOT). */
export const AI_RUNTIME_PROVIDER_IDS = aiProviderIdSchema.options;

/** Text LLM credential providers (excludes STT-only speechkit). */
export const AI_TEXT_CREDENTIAL_PROVIDER_IDS: readonly AiProviderStatusId[] =
  AI_PROVIDER_STATUS_IDS.filter((id) => id !== 'speechkit');

/** Direct HTTP API providers for platform model ids (excludes remote_runner). */
export const AI_DIRECT_API_PROVIDER_IDS: readonly Exclude<AiProviderId, 'remote_runner'>[] =
  AI_RUNTIME_PROVIDER_IDS.filter((id): id is Exclude<AiProviderId, 'remote_runner'> => id !== 'remote_runner');

export function parseAiProviderStatusId(value: string): AiProviderStatusId | null {
  const trimmed = value.trim();
  return (AI_PROVIDER_STATUS_IDS as readonly string[]).includes(trimmed)
    ? (trimmed as AiProviderStatusId)
    : null;
}

export function parseAiProviderId(value: string): AiProviderId | null {
  const trimmed = value.trim();
  return (AI_RUNTIME_PROVIDER_IDS as readonly string[]).includes(trimmed) ? (trimmed as AiProviderId) : null;
}

export function parseDirectApiProviderId(
  value: string,
): Exclude<AiProviderId, 'remote_runner'> | null {
  const parsed = parseAiProviderId(value);
  if (!parsed || parsed === 'remote_runner') return null;
  return parsed;
}

export function isDirectApiProviderId(provider: AiProviderId): provider is Exclude<AiProviderId, 'remote_runner'> {
  return provider !== 'remote_runner';
}

/** Maps stored provider id to Platform Kit wire provider (OpenAI-compatible → openai). */
export function toRuntimeWireProvider(
  provider: Exclude<AiProviderId, 'remote_runner'>,
): 'yandex' | 'deepseek' | 'openai' | 'anthropic' | 'openrouter' {
  return provider === 'openai_compatible' ? 'openai' : provider;
}
